import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import { createRouter } from "./router";
import "./styles/overrides.scss";
import "../public/css/bootstrap.min.css";
// import "./styles/player.scss";

// Vue.config.productionTip = false;
import store from "./store";

import i18n from "./i18n";
import { initRequest } from "./util/request";

const router = createRouter();
initRequest();
new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
